export enum LabourForecastRoles {
  LABOUR_FORECAST_MANAGER = 'roles.labourForecastManager',
}
